/* eslint-disable react/jsx-pascal-case */
import { ChangeHistory, Key, Person, Settings, Aod, AdminPanelSettings, Star } from '@mui/icons-material'
import { useMediaQuery } from '@mui/material'
import React, { useContext, useState, useEffect } from 'react'
import { BufferService, LoadingContext, M_TabsInpage } from 'src/M_Components'
import { ChangePassword } from './ChangePassword'
import ChangeLogPage from 'src/pages/changeLogPage'
import ChangeLogAdminPage from 'src/pages/changeLogAdminPage'
import { Profile } from './Profile'
import { Configuration } from './Configuration'
import { useTranslation } from 'react-i18next'
import { Audit } from './audit'
import { FavoritesSettings } from './FavoritesSettings'

export const SettingsPage = () => {
  const ctx = useContext(LoadingContext)
  const matches = useMediaQuery('(min-width:1200px)')
  const [menu, setMenu] = useState(1)
  const [user, setUser] = useState(null)
  const UserService = new BufferService('identity/userrole')
  const [version, setVersion] = useState('')
  const { t } = useTranslation()

  useEffect(() => {
    ctx.setIsLoad(true)
    getVersion()
    UserService.get().then(res => {
      ctx.setIsLoad(false)
      if (res.name === 'AxiosError') {
        ctx.toastMessages('error', res.response.data.Errors.toString())
        return
      }
      console.log(res)
      setUser(res)
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function getVersion() {
    const newVersion = await fetch('/version.txt')
    const versionText = await newVersion.text()
    setVersion(JSON.parse(versionText))
  }

  const settingsMenu = () => {
    const tempArray = [
      { iconTab: <Person />, labelTab: t("Profile"), id: 1 },
      { iconTab: <Settings />, labelTab: t('Configuration'), id: 2 },
      { iconTab: <Key />, labelTab: t('ChangePassword'), id: 3 },
      { iconTab: <Star />, labelTab: t('Favorites'), id: 5 },
    ]

    if (user?.RoleDetails.some(obj => obj.Value === 'auditList')) {
      tempArray.push({ iconTab: <Aod />, labelTab: t('Audit'), id: 6 })
    }

    // ChangeLog para todos os utilizadores
    tempArray.push({ iconTab: <ChangeHistory />, labelTab: t('ChangesLog'), id: 7 })

    // Gestão de ChangeLog para SuperAdmin e Admin
    const isSuperAdmin = user?.Role?.some(role => role.Name === 'SuperAdmin')
    const isAdmin = user?.Role?.some(role => role.Name === 'Admin')
    if (isSuperAdmin || isAdmin) {
      tempArray.push({ iconTab: <AdminPanelSettings />, labelTab: t('ManageChangelog'), id: 8 })
    }

    return tempArray
  }

  return (
    <div style={{ marginTop: '50px' }}>
      <div style={matches ? { display: 'flex', } : {}}>
        <div style={matches ? { marginLeft: '20px', width: '300px', } : {}}>
          <M_TabsInpage
            type={matches ? 'column' : 'tabs'}
            // renderTabs={[
            //   // { iconTab: <Person />, labelTab: t("Profile"), id: 1 },
            //   // { iconTab: <Settings />, labelTab: t('Configuration'), id: 2 },
            //   // { iconTab: <Key />, labelTab: t('ChangePassword'), id: 3 },
            //   // { iconTab: <Aod />, labelTab: t('Audit'), id: 5 },
            //   // { iconTab: <Schedule />, labelTab: 'Recent Activity', id: 4 },
            //   { iconTab: <i className="pi pi-wrench"></i>, labelTab: t('ChangesLog'), id: 6 },
            // ]}
            renderTabs={settingsMenu()}
            onGetTab={(obj) => {
              setMenu(obj.id)
            }}
          />
        </div>
        <div style={{ position: 'absolute', bottom: '5px', left: '5px' }}>
          Webtrans Version {version}
        </div>
        <div style={{ width: '80%', margin: '20px' }}>
          {
            menu === 1 &&
            <div>
              <Profile User={user} />
            </div>
          }
          {
            menu === 2 &&
            <div>
              <Configuration />
            </div>
          }
          {
            menu === 3 &&
            <div>
              <ChangePassword Email={user?.User?.Email} />
            </div>
          }
          {
            menu === 4 &&
            <div>
              Recent Activity
            </div>
          }
          {
            menu === 5 &&
            <div>
              <FavoritesSettings />
            </div>
          }
          {
            menu === 6 && user?.RoleDetails.some(obj => obj.Value === 'auditList') &&
            <div>
              <Audit />
            </div>
          }
          {
            menu === 7 &&
            <div>
              <ChangeLogPage />
            </div>
          }
          {
            menu === 8 && (user?.Role?.some(role => role.Name === 'SuperAdmin') || user?.Role?.some(role => role.Name === 'Admin')) &&
            <div>
              <ChangeLogAdminPage />
            </div>
          }

        </div>
      </div>
    </div>
  )
}
